import config from '../config';
import cottonFlagManager from './featureFlags/cotton';
import { isTargetAuthEnabled, base, buildCottonForceConnectUrl } from './auth';
import { COTTON_DISCONNECT } from './cottonApis';

export const forceLogout = ({ basePath = '' } = {}) => {
  const {
    href,
    origin,
  } = window.location;
  // The current location we want to redirect the client back to after they enter their password
  const afterAuthContinueURL = encodeURIComponent(href);
  const { isCottonEnabled } = cottonFlagManager;
  // Choose the force_connect endpoint and redirect accordingly.
  let forceConnectAbsoluteUrl;
  if (isCottonEnabled) {
    forceConnectAbsoluteUrl = buildCottonForceConnectUrl(href);
    const forceConnectUrl = encodeURIComponent(forceConnectAbsoluteUrl);
    // Stay same-origin via /oauth/disconnect; avoids dev redirect via CIMA client ID
    window.location.replace(`${base()}/oauth/disconnect?continue=${forceConnectUrl}`);
    return;
  }
  if (isTargetAuthEnabled()) {
    forceConnectAbsoluteUrl = `${origin}${basePath}/oauth/force_connect_v2?continue=${afterAuthContinueURL}`;
  } else {
    forceConnectAbsoluteUrl = `${origin}${basePath}/oauth/force_connect?continue=${afterAuthContinueURL}`;
  }
  // Send the browser through the full SLO for non-cotton users
  const forceConnectUrl = encodeURIComponent(forceConnectAbsoluteUrl);
  const { cimaClientId } = config();
  window.location.replace(`https://oauth.xfinity.com/oauth/sp-logout?client_id=${cimaClientId}&state=${forceConnectUrl}`);
};

export const cottonForceDisconnect = () => {
  const { href } = window.location;
  const forceConnectUrl = encodeURIComponent(buildCottonForceConnectUrl(href));

  // Send the browser to the cotton/oauth/disconnect endpoint to destroy the cotton session and
  // isAuth cookies.
  window.location.replace(`${base()}${COTTON_DISCONNECT}?continue=${forceConnectUrl}`);
};

export default forceLogout;
